<template>
  <div class="lucky-dip-cell" v-press="() => emit('select')">
    <div class="lucky-dip-image-wrapper">
      <img
        class="lucky-dip-image lazy"
        :data-src="item.imageUrl"
        :alt="title"
      />
      <div v-if="loading" class="lucky-dip-loading">
        <TG4Loader small hide-label />
      </div>

    </div>

    
    <div class="lucky-dip-text">
      <h3 class="lucky-dip-title">{{ title }}</h3>
      <p class="lucky-dip-subtitle" v-if="subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">

import { computed } from 'vue';
import { RailLuckyDipItem } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import TG4Loader from '@/components/TG4Loader.vue';

const props = defineProps<{
  item: RailLuckyDipItem;
  loading?: boolean;
}>();

const emit = defineEmits<{
  (e: 'select'): void
}>();

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const isIrish = computed(() => currentLanguage.value === Language.Irish);

const title = computed(() => (isIrish.value ? props.item.titleGa : props.item.titleEn));

const subtitle = computed(() => {
  const value = isIrish.value ? props.item.subtitleGa : props.item.subtitleEn;
  return value ?? props.item.subtitleEn ?? '';
});
</script>

<style scoped lang="scss">
.lucky-dip-cell {
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  width: $episode-cell-width;
  margin-top: 5px;
  outline: 0;

  display: flex;
  flex-direction: column;


  &:focus {
    .lucky-dip-image-wrapper {
      border-color: $color-pink;
    }
  }
}

.lucky-dip-image-wrapper {
  position: relative;
  box-sizing: border-box;
  padding-bottom: 56.25%; // 9 / 16
  overflow: hidden;
  border: $focus-border-width solid transparent;
}

.lucky-dip-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lucky-dip-loading {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.lucky-dip-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
}

.lucky-dip-text {
  text-align: left;
}

.lucky-dip-title {
  margin: 0;
  @include text-cell-title;
  @include text-white;
  @include line-clamp(2);
}

.lucky-dip-subtitle {
  margin: 0;
  @include text-cell-subtitle;
  @include text-white;
  @include truncate;
}
</style>
